import { signOut } from 'firebase/auth';
import React from 'react';
import { Container, Nav, Navbar } from 'react-bootstrap';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Link } from 'react-router-dom';
import CustomLink from '../../../../CustomLink/CustomLink';
import auth from '../../../../firebase.init';
import './Header.css'

const Header = () => {
  const [user, loading, error] = useAuthState(auth);
  const logout = () => {
    signOut(auth);
  };
  return (
<Navbar fixed="top" expand="lg">
  <Container>
    <Navbar.Brand>
    <Link to='/'>
    Frame It
    </Link>
    </Navbar.Brand>
    <Navbar.Toggle aria-controls="basic-navbar-nav" />
    <Navbar.Collapse id="basic-navbar-nav">
      <Nav className="mx-auto">
      <CustomLink to='/'>Home</CustomLink>
        <CustomLink to='/services'>Services</CustomLink>
        <CustomLink to='/blogs'>Blogs</CustomLink>
        <CustomLink to='/about'>About</CustomLink>
        {user ? '' :  <CustomLink to='/login'>Login</CustomLink>}
        {user ? '' : <CustomLink className='signup_btn' to='/signup'>Sign up</CustomLink>}
        {user ? <Link to='/' onClick={logout}>Logout</Link> : ''}
        {user ? <div className="user_info">
      {user?.photoURL ? <img src={user?.photoURL} alt={user?.displayName} title={user?.displayName} /> : user?.displayName || user?.email}
    </div> : ''}
      </Nav>
    </Navbar.Collapse>
    
  </Container>
</Navbar>
  );
};

export default Header;